export default __webpack_public_path__ + "static/media/01.14498544.jpg";